var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    _vm._b(
      {
        attrs: {
          title: _vm.title,
          visible: _vm.dialog,
          width: _vm.width,
          fullscreen: _vm.fullscreen,
          "append-to-body": "",
          "destroy-on-close": _vm.destoryOnClone,
          "close-on-click-modal": false,
        },
        on: {
          opened: function ($event) {
            return _vm.$emit("opened")
          },
          closed: function ($event) {
            return _vm.$emit("closed")
          },
          close: function ($event) {
            return _vm.$emit("update:dialog", false)
          },
        },
      },
      "el-dialog",
      _vm.$attrs,
      false
    ),
    [
      _vm._t("default"),
      _vm._t("footer", function () {
        return [
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:dialog", false)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("FetchSet.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    loading: _vm.loadingqued,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("handleOk", _vm.$slots.default)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("FetchSet.confirm")))]
              ),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }